import './style.css';
import Router from 'preact-router';

if (process.env.PREACT_APP_ENV === 'development') {
  // Must use require here as import statements are only allowed
  // to exist at top-level.
  require('preact/debug');
}
// import VConsole from 'vconsole';

// new VConsole();
import { h, render } from 'preact';
import Index from './home/index';


const App = () => {
  return (
    <Router>
      <Index path='/'/>
      {/* <LotterRecord path='/record'/>
      <Subsidy path='/s'/>
      <S2 path='/s2' />
      <InterView path ='/interview' />
      <Search path='/search'/> */}
    </Router>
  )

};

if (typeof window !== "undefined") render(<App />, document.body)